module.exports = __webpack_public_path__ + "static/media/UploadIcon.1cedb6e9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-images-upload/UploadIcon.svg
// module id = 1056
// module chunks = 18